<template>
  <el-dialog
    :visible.sync="detailVisible"
    width="1220px"
    :show-close="false"
    :before-close="closeDialog"
    @opened="initQuery"
  >
    <div class="title">企业详情</div>
    <div class="basic-info border">
      <div class="sub-title">企业基础信息</div>
      <div class="info-ins">
        <div class="info-item">
          <div class="item">
            <span class="item-title">统一社会信用代码</span>
            <span class="item-text">{{ enterpriseDetail.tax_no }}</span>
          </div>
          <div class="item">
            <span class="item-title">企业名称</span>
            <span class="item-text">{{ enterpriseDetail.organ_name }}</span>
          </div>
          <div class="item">
            <span class="item-title">企业类型</span>
            <span class="item-text">{{ enterpriseDetail.ent_type_text }}</span>
          </div>
          <div class="item">
            <span class="item-title">注册资金</span>
            <span class="item-text">{{ enterpriseDetail.reg_capital }}</span>
          </div>
        </div>
        <div class="info-item">
          <div class="item">
            <span class="item-title">企业地址</span>
            <span class="item-text">{{ enterpriseDetail.ent_address }}</span>
          </div>
          <div class="item">
            <span class="item-title">法定代表人</span>
            <span class="item-text">{{ enterpriseDetail.ent_principal }}</span>
          </div>
          <div class="item">
            <span class="item-title">联系人</span>
            <span class="item-text">{{ enterpriseDetail.comp_contact }}</span>
          </div>
          <div class="item">
            <span class="item-title">联系电话</span>
            <span class="item-text">{{ enterpriseDetail.phone }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="drug-list border" v-show="showDrugList">
      <div class="sub-title">生产药品列表</div>
      <el-table :data="drugList">
        <el-table-column label="药品通用名称" prop="drug_name" />
        <el-table-column label="药品批准文号" prop="license_no" />
        <el-table-column label="制剂规格" prop="drug_spec" />
        <el-table-column label="剂型" prop="drug_form" />
        <el-table-column label="是否处方药" prop="is_prescribed" />
        <el-table-column label="药品种类" prop="product_type" />
        <!-- <el-table-column label="生产状态" prop="produce_state" /> -->
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, prev, pager, next, jumper"
        :total="drugTotal"
        :current-page="drugCurrentPage"
        @current-change="loadDrugList"
        :page-size="5"
      />
    </div>
    <div class="supplier-list border">
      <div class="sub-title">供应商白名单</div>
      <el-table :data="supplierList">
        <el-table-column label="统一社会信用代码" prop="org_code" />
        <el-table-column label="供应商名称" prop="supplier_name" />
        <el-table-column label="法定代表人" prop="ent_principal" />
        <el-table-column label="联系人" prop="comp_contact" />
        <el-table-column label="联系电话" prop="contact_tel" />
        <el-table-column
          label="供应商地址"
          show-overflow-tooltip
          prop="supplier_address"
        />
      </el-table>
      <el-pagination
        class="pagination"
        layout="total, prev, pager, next, jumper"
        :total="supplierTotal"
        :current-page="supplierCurrentPage"
        :page-size="3"
        @current-change="loadSupplierList"
      />
    </div>
    <div class="position border">
      <div class="sub-title">地理位置</div>
      <div class="map">
        <el-amap vid="amap" class="amap" :center="center" :zoom="12">
          <el-amap-marker
            vid="component-marker"
            :position="center"
          ></el-amap-marker>
        </el-amap>
      </div>
    </div>
    <el-button type="default" @click="closeDialog" class="back">返回</el-button>
  </el-dialog>
</template>

<script>
export default {
  props: {
    detailVisible: Boolean,
    closeDialog: Function,
    showDrugList: {
      type: Boolean,
      default: true
    },
    enterpriseId: String
  },
  data() {
    return {
      enterpriseDetail: {
        comp_name: '',
        ent_address: '',
        ent_principal: '',
        comp_contact: '',
        ent_type: '',
        ent_type_text: '',
        latitude: '',
        longitude: '',
        organ_name: '',
        phone: '',
        reg_capital: '',
        tax_no: ''
      },
      drugList: [],
      drugCurrentPage: 1,
      drugTotal: 0,
      supplierList: [],
      supplierCurrentPage: 1,
      supplierTotal: 0,
      center: [116, 40]
    };
  },
  methods: {
    initQuery() {
      this.loadEnterpriseDetail();
      if (this.showDrugList) {
        this.loadDrugList(1);
      }
      this.loadSupplierList(1);
    },
    // 企业详情
    loadEnterpriseDetail() {
      const handlerName = this.showDrugList
        ? 'query_proEnt_detail'
        : 'query_bpent_detail';
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            dict: {},
            pageBean: { pageNum: 1, pageSize: 1000 },
            params: {
              handlerName,
              organId: this.enterpriseId
            }
          })
        }
      }).then(res => {
        for (const key in this.enterpriseDetail) {
          this.enterpriseDetail[key] = res.list[0][key] || '';
          this.enterpriseDetail.ent_type_text = this.$common.entTypeMap[
            this.enterpriseDetail.ent_type
          ];
          this.center = [
            this.enterpriseDetail.longitude || 116,
            this.enterpriseDetail.latitude || 40
          ];
        }
      });
    },
    // 供应商白名单
    loadSupplierList(currentPage) {
      this.supplierCurrentPage = currentPage;
      const handlerName = this.showDrugList
        ? 'query_pro_supplier_list'
        : 'query_bpent_supplier_list';
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            dict: {},
            pageBean: { pageNum: this.supplierCurrentPage, pageSize: 3 },
            params: {
              handlerName,
              organId: this.enterpriseId
            }
          })
        }
      }).then(res => {
        this.supplierList = res ? res.list : [];
        this.supplierTotal = res ? res.total : 0;
      });
    },
    // 药品列表
    loadDrugList(currentPage) {
      this.drugCurrentPage = currentPage;
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this.drugCurrentPage,
              pageSize: 5
            },
            params: {
              handlerName: 'query_druglist_byorganid',
              organId: this.enterpriseId
            }
          })
        }
      }).then(res => {
        this.drugTotal = res ? res.total : 0;
        this.drugList = res ? res.list : [];
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
>>>.el-dialog__header
  padding 0
>>>.el-dialog__body
  padding-top 0
.title
  font-size 20px
  color #242424
  text-align center
  line-height 75px
.border
  border 1px solid rgba(204,204,204,.4)
  margin-bottom 20px
.sub-title
  line-height 60px
  font-size 16px
  color #000
  text-align center
  font-weight bold
.drug-list, .supplier-list
  padding 0 20px
  overflow hidden
  .pagination
    float right
    padding 20px 0
.info-ins
  display flex
  font-size 14px
  padding-left 100px
  padding-right 30px
  .info-item
    width 50%
    .item
      margin-bottom 20px
      display flex
      .item-title
        display inline-block
        width 120px
        text-align right
        margin-right 20px
        color #000
      .item-text
        display inline-block
        flex 1
        color #666
.map
  width 817px
  height 303px
  margin 0 auto 25px auto
.back
  display block
  margin 0 auto
</style>
